import { Route, Routes, Navigate, BrowserRouter, Outlet } from "react-router-dom";

// --| Styles
import "./styles/App.css";
import "./styles/color.css";
import "./pages/auth/auth.css";

// pages
import Error from "./pages/error/Error";
import Login from "./pages/auth/Login";
import Signup from "./pages/auth/Signup";
// import AdminSignup from "./pages/auth/signup/AdminSignup";
import ResetPassword from "./pages/auth/signup/ResetPassword";
import AdminForgotPassword from "./pages/auth/signup/ForgotPassword";
import Pricing from "./pages/pricing/Pricing";
import Report from "./pages/report/Report";
import Notification from "./pages/notification/Notification";
import ForgotPassword from "./pages/auth/ForgotPassword";
import EmailTemplate from "./pages/emailtemplate/EmailTemplate";
// import LatencyTest from "./pages/latencytest/LatencyTest";
import SchoolAPI from "./pages/latencytest/components/SchoolApiInfo";
import VerificationSuccess from "./pages/auth/VerificationSuccess";
import LeaveMgt from "./pages/leavemgt/LeaveMgt";
import SchoolLeaveOptions from "./pages/schools/leavemgt/LeaveOptionDetails";
import LeaveOption from "./pages/leavemgt/LeaveOptions";
import Marketplace from "./pages/marketplace/Marketplace";
import WelcomeToShelf from "./pages/onboarding/WelcomeToShelf";
import PerfEval from "./pages/perfeval/PervEval";
import GoalCategory from "./pages/schools/perfeval/GoalCategory";
import Resources from "./pages/resources/Resources";
import Resource from "./pages/resources/Resource";
import Settings from "./pages/settings/Settings";
import Schools from "./pages/schools/Schools";
import SchoolSessions from "./pages/schools/schoolplan/SchoolSession";
import SchoolTerms from "./pages/schools/schoolplan/SchoolTerm";
import AllSubjectInfo from "./pages/schools/subject/AllSubjectInfo";
import ContactDetails from "./pages/schools/classes/ClassDetails";
import SchoolPeperReview from "./pages/schools/examination/SchoolPaperReview";
import ExaminationPaperReview from "./pages/schools/examination/ExaminationReview";
import AboutSchool from "./pages/schools/component/AboutSchool";
import AboutSchoolStaffs from "./pages/schools/staffs/AboutStaff";
import AboutStudent from "./pages/schools/student/Studentinfo";
import ApiUsage from "./pages/settings/components/ApiUsage";
import Teachers from "./pages/teachers/Teachers";
import Teacher from "./pages/teachers/Teacher";
import Welfare from "./pages/welfare/Welfare";
import Dashboard from "./pages/dashboard/Dashboard";
import Profile from "./pages/profile/index";
import CreateInventory from "./pages/schools/inventory/CreateInventory";
import ArchivedInventory from "./pages/schools/inventory/ArchivedInventory";
import User from "./pages/User/Index";
// import Dashboard from "./pages/dashboard/Dashboard";
import CreateAccess from "./pages/schools/accessControl/component/CreateAccess";
// context
import { useUserState } from "./context/UserContext";
// eslint-disable-next-line no-duplicate-imports
import AboutStaff from "./pages/schools/staffs/AboutStaff";
import LeaveDetails from "./pages/schools/leavemgt/LeaveMgtDetails";
import ApplicationDetails from "./pages/schools/component/ApplicationDetails";
import CreateEnrolments from "./pages/schools/Enrolments/CreateEnrolments";
import CreateExam from "./pages/schools/examination/component/CreateExam";
import EditSchoolExam from "./pages/schools/examination/component/EditSchoolExam";
import SchoolExamDetails from "./pages/schools/examination/component/SchoolExamDetails";
import CreateAssignment from "./pages/schools/assignment/components/AdminCreateAssignment";
import EditAssignment from "./pages/schools/assignment/components/EditAssignment";
import AssignmentDetail from "./pages/schools/assignment/components/AssignmentDetail";
import ViewLessonNote from "./pages/schools/lessonnote/ViewLessonNote";
import CreateLessonNote from "./pages/schools/lessonnote/CreateLessonNote";
import ViewSubjectLessonNote from "./pages/schools/lessonnote/ViewSubjectLessonNote";
import EmployeeDetails from "./pages/User/EmployeeDetail";
import ValidateCode from "./pages/schools/accessControl/component/ValidateCode";
import Subscription from "./pages/subscription/Index";
import Support from "./pages/support/index";
import Partner from "./pages/Partner/Index";
import ViewTicket from "./pages/support/components/ViewTicket";
import Rewards from "./pages/rewards/Rewards";
import SubmissionReview from "./pages/rewards/SubmissionReview";
import Withdrawals from "./pages/rewards/Withdrawals";
import EmailManagement from "./pages/emailmanagement/index";
import QuestionPool from "./pages/questionpool/QuestionPool";
import CreateQuestion from "./pages/questionpool/CreateQuestion";
import Marketing from "./pages/marketing/Marketing";
import Referrers from "./pages/referrers/Referrers";
import AuthenticatedReferrers from "./pages/referrers/AuthenticatedReferrers";

export default function App() {
  // global
  // const { isAuthenticated } = useUserState();

  const { isAuthenticated } = useUserState();

  const AuthenticatedRoute = () => {
    return isAuthenticated ? <Outlet /> : <Navigate to="/auth/login" />;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* This Redirect root URL based on authentication */}
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/auth/login" />}
          />
          <Route path="/" element={<AuthenticatedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/admin-forgot-password" element={<AdminForgotPassword />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/reports" element={<Report />} />
            <Route path="/notification" element={<Notification />} />
            <Route path="/email-template" element={<EmailTemplate />} />
            <Route path="/user" element={<User />} />
            <Route path="/latency-test/:id" element={<SchoolAPI />} />
            <Route path="/leavemgt" element={<LeaveMgt />} />
            <Route path="/schools/:id/leaveoptions" element={<LeaveOption />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/perfeval" element={<PerfEval />} />
            <Route path="/goal-category/:id" element={<GoalCategory />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:id" element={<Resource />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/settings/:id" element={<ApiUsage />} />
            <Route path="/rewards" element={<Rewards />} />
            <Route path="/rewards/:id" element={<SubmissionReview />} />
            <Route path="/withdrawals" element={<Withdrawals />} />
            <Route path="/teachers" element={<Teachers />} />
            <Route path="/schools" element={<Schools />} />
            <Route path="/schools/:id" element={<AboutSchool />} />
            <Route path="/schools/staffs/:id" element={<AboutSchoolStaffs />} />
            <Route path="/schools/sessions/:id" element={<SchoolSessions />} />
            <Route path="/schools/terms/:id" element={<SchoolTerms />} />
            <Route path="/schools/classes/:id" element={<ContactDetails />} />
            <Route path="/schools/leaveoptions/:id" element={<SchoolLeaveOptions />} />
            <Route path="/schools/leavedetails/:id" element={<LeaveDetails />} />
            <Route path="/teachers/:id" element={<Teacher />} />
            <Route path="/schools/student/:id" element={<AboutStudent />} />
            <Route path="/admin/employees/:id" element={<AboutStaff />} />
            <Route path="/schools/school-paper-review" element={<SchoolPeperReview />} />
            <Route path="/schools/school-paper-review/:id" element={<ExaminationPaperReview />} />
            <Route path="/onboarding" element={<WelcomeToShelf />} />
            <Route path="/schools/:id/archive-inventory" element={<ArchivedInventory />} />
            <Route path="/schools/:id/create-inventory" element={<CreateInventory />} />
            <Route path="/schools/subjects/:id" element={<AllSubjectInfo />} />
            <Route path="/welfare" element={<Welfare />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/marketing" element={<Marketing />} />
            <Route path="/referrers/unauthenticated" element={<Referrers />} />
            <Route path="/referrers/authenticated" element={<AuthenticatedReferrers />} />
            <Route path="/referrers" element={<Navigate to="/referrers/unauthenticated" replace />} />
            <Route path="/support/tickets" element={<Support />} />
            <Route path="/support/ticket/:id" element={<ViewTicket />} />
            <Route path="/schools/applications/:id" element={<ApplicationDetails />} />
            <Route path="/schools/:id/enrolments/create" element={<CreateEnrolments />} />
            <Route path="/schools/:id/accesscontrol/create" element={<CreateAccess />} />
            <Route path="/schools/:id/accesscontrol/validate" element={<ValidateCode />} />
            <Route path="/schools/:id/create/:user/examination" element={<CreateExam />} />
            <Route path="/schools/edit-examination/:id/:schoolId" element={<EditSchoolExam />} />
            <Route path="/schools/examination-details/:id/:schoolId" element={<SchoolExamDetails />} />
            <Route path="/schools/:id/create-assignment/:user" element={<CreateAssignment />} />
            <Route path="/schools/:schoolId/edit-assignments/:id" element={<EditAssignment />} />
            <Route path="/assignments/:schoolId/:id" element={<AssignmentDetail />} />
            <Route path="/schools/:schoolId/lesson-notes/:id/" element={<ViewLessonNote />} />
            <Route path="/email-management" element={<EmailManagement />} />
            <Route path="/question-pool" element={<QuestionPool />} />
            <Route path="/question-pool/create" element={<CreateQuestion />} />
            <Route
              path="/schools/:id/create-lesson-outline"
              element={<CreateLessonNote />}
            />
            <Route path="/schools/:schoolId/view-lesson-outlines/:id" element={<ViewSubjectLessonNote />} />
            <Route path="/subscription" element={<Subscription />} />
            <Route path="/schools/users/:id" element={<EmployeeDetails />} />
          </Route>
          <Route index path="/auth/login" element={<Login />} />
          <Route path="*" element={<Error />} />
          {/* <Route path="/auth/signup" element={<AdminSignup />} /> */}
          <Route path="/auth/signup" element={<Signup />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/verify-success" element={<VerificationSuccess />} />
        </Routes>

      </BrowserRouter>
    </div>
  );

  // #######################################################################

  // function PublicRoute () {
  //   return  <Outlet />
  // }
}
